import {applicationName} from "../utils";

export const getNewsclueById = (id)=> new Promise((resolve, reject) => {
    let time = new Date().getTime();
    let url = "/cm-sites-"+applicationName()+"/newsclue/getById";
    let params = {
        id,time
    };
    window.$.ajax({
        type:"post",
        url: url,
        data:params,
        dataType:"json",
        success:function (result) {
            if(result){
                resolve(result);
            }else{
                reject({});
            }
        },
        error:function (e) {
            console.error(e);
            reject({});
        }
    });
});
